import axios from 'axios';

export default {
    ERROR_TIMEOUT: 1,
    ERROR_UNAUTHORIZED: 2,
    ERROR_WHATEVER: 3,

    DevelopmentProfile: {
        name: 'Simen Eriksen',
        email: 'simen.eriksen@gmail.com',
        picture: 'https://lh4.googleusercontent.com/-LQfYopo9Tb0/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucm85JB-N2O1iG0lGiuJMnKbHJb9lA/s96-c/photo.jpg',
    },
    isDevelopment() {
        return process.env.NODE_ENV === 'development';
    },
    loginLinkGoogle() {
        return this.isDevelopment() ? '/profiles/me' : '/.auth/login/google?access_type=offline&post_login_redirect_url=/';
    },
    refreshAuth() {
        if (this.isDevelopment()) return new Promise(resolve => resolve({}));
        return axios.get('/.auth/refresh', { timeout: 2000 }).catch(error => {
            if (error.response && error.response.status === 401) return { error: this.ERROR_UNAUTHORIZED };
            console.log(error);
            return {};
        });
    },
    getAuth() {
        if (this.isDevelopment()) return new Promise(resolve => resolve(this.DevelopmentProfile));
        return axios
            .get('/.auth/me', { timeout: 2000 })
            .then(response => ({
                name: response.data[0].user_claims.find(c => c.typ === 'name').val,
                email: response.data[0].user_id,
                picture: response.data[0].user_claims.find(c => c.typ === 'picture').val,
            }))
            .catch(error => {
                console.log(error);
                return { error: this.ERROR_WHATEVER };
            });
    },
    dropAuth() {
        if (this.isDevelopment()) return new Promise(resolve => resolve({}));
        return axios.get('/.auth/logout', { timeout: 5000 }).catch(error => ({ error }));
    },
};
